import Vue from "vue";

import { CrudField } from "./CrudField";
import { CrudModel } from "./CrudModel";
import { UserPermissions } from "./UserPermission";

import { CrudCollection } from "./CrudCollection";
import { CrudLayout } from "./CrudLayout";
import { CrudProperty } from "./CrudProperty";

import * as components from "./components";

import { registerCoreTypes } from "./registerCoreTypes";

export function initConfig(userCrudObjects, context = { $auth: {}, $api: {} }) {
  // context
  CrudModel.setNuxtContext(context);
  CrudField.setNuxtContext(context);
  CrudLayout.setNuxtContext(context);
  CrudProperty.setNuxtContext(context);
  CrudCollection.setNuxtContext(context);
  UserPermissions.setNuxtContext(context);

  // every type registry (models, properties, fields, layouts, conditionals,
  // rules) -- kept in registerCoreTypes.ts so a plain-Node caller can populate
  // them without importing Vue or any SFC under ./components
  registerCoreTypes(userCrudObjects);

  // components
  Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
    Vue.component(toKebab(name), components[name]);
  });
}

// https://www.geeksforgeeks.org/how-to-convert-a-string-into-kebab-case-using-javascript/
const toKebab = (str) =>
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .join("-")
    .toLowerCase();
